import { render } from "./bby.vue?vue&type=template&id=c82a5258&scoped=true"
import script from "./bby.vue?vue&type=script&lang=js"
export * from "./bby.vue?vue&type=script&lang=js"

import "./bby.vue?vue&type=style&index=0&id=c82a5258&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c82a5258"]])

export default __exports__